import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  SubscriptionIcon: {
    width: 42,
    height: 42,
    marginRight: 22,
  },
  SubscriptionContainer: {
    paddingTop: 16.6,
    paddingRight: 18.7,
    paddingLeft: 16.3,
  },
  SubscriptionText: theme => ({
    color: theme.colors.text.primary,
    fontSize: 16.6,
  }),
  SubscriptionIconsContainer: {
    flexDirection: 'row',
    marginTop: 16.6,
    paddingBottom: 24.6,
  },
});
